// src/api/api.js

const API_BASE =
  process.env.REACT_APP_API_URL || "/api";

let reauthInProgress = false;

function startMicrosoftReauthentication() {
  // Prevent multiple simultaneous failed API requests from each
  // attempting to start their own Microsoft authentication flow.
  if (reauthInProgress) {
    return;
  }

  reauthInProgress = true;

  // Remember exactly where the user currently is.
  const currentLocation =
    window.location.pathname +
    window.location.search +
    window.location.hash;

  // Don't save authentication pages as destinations.
  if (
    !currentLocation.startsWith("/login")
  ) {
    sessionStorage.setItem(
      "post_login_redirect",
      currentLocation
    );
  }

  // The existing Nightjar token is expired and is no longer useful.
  localStorage.removeItem("lumat_token");

  // Start a fresh Microsoft SSO authentication.
  // If the Microsoft session is still active, this should normally
  // complete without the user entering their credentials again.
  window.location.href =
    `${API_BASE}/auth/microsoft`;
}

export default async function api(path, options = {}) {
  const token =
    localStorage.getItem("lumat_token");

  const isFormData =
    options.body instanceof FormData;

  const headers = {
    ...(token
      ? { Authorization: `Bearer ${token}` }
      : {}),
    ...(!isFormData
      ? { "Content-Type": "application/json" }
      : {}),
    ...(options.headers || {}),
  };

  const res = await fetch(
    `${API_BASE}${path}`,
    {
      ...options,
      headers,
    }
  );

  if (!res.ok) {
    let errorMessage;
    let errorCode;

    try {
      const errJson = await res.json();

      errorMessage =
        errJson.error || res.statusText;

      errorCode =
        errJson.code;
    } catch {
      errorMessage = res.statusText;
    }

    // Only automatically reauthenticate when the backend
    // explicitly tells us the Nightjar JWT has expired.
    if (
      res.status === 401 &&
      errorCode === "TOKEN_EXPIRED"
    ) {
      startMicrosoftReauthentication();

      throw new Error(
        "Session expired. Reauthenticating..."
      );
    }

    throw new Error(
      `API ${res.status}: ${errorMessage}`
    );
  }

  // Handle no-body responses (204 No Content)
  if (res.status === 204) {
    return null;
  }

  return res.json();
}